/**
 * Query Key factory for all timeline queries.
 *
 * @module Timeline
 */

export const timelineQKeys = {
  all: () => ["timeline"] as const,

  patients: () => [...timelineQKeys.all(), "patient"] as const,

  patient: (patientId: string) =>
    [...timelineQKeys.patients(), patientId] as const,
};
